// for css attribute:
import "styled-components/macro";
import PropTypes from "prop-types";

import { StyledAction } from "shared/components/data-display/drawers/MasterDrawer.styles";
import PrimaryButton from "shared/components/inputs/button/PrimaryButton";
import SecondaryButton from "shared/components/inputs/button/SecondaryButton";
import TertiaryButton from "shared/components/inputs/button/TertiaryButton";
import VStack from "shared/components/layout/stack/VStack";
import DrawerContext from "shared/contexts/DrawerContext";
import { useContext } from "react";

const DrawerActions = ({
    primaryAction,
    secondaryAction,
    tertiaryAction,
    isCTAAllActions = false,
    ...rest
}) => {
    const { isCTAPrimaryAction } = useContext(DrawerContext);

    return (
        <StyledAction
            isCTAPrimaryAction={isCTAPrimaryAction}
            isCTAAllActions={isCTAAllActions}
            {...rest}
        >
            <VStack>
                {primaryAction && <PrimaryButton {...primaryAction} />}
                {secondaryAction && <SecondaryButton {...secondaryAction} />}
                {tertiaryAction && (
                    <TertiaryButton
                        {...tertiaryAction}
                        style={{ width: "max-content", margin: "0 auto" }}
                    />
                )}
            </VStack>
        </StyledAction>
    );
};

DrawerActions.propTypes = {
    primaryAction: PropTypes.object,
    secondaryAction: PropTypes.object,
    tertiaryAction: PropTypes.object,
    isCTAAllActions: PropTypes.bool,
};

export default DrawerActions;
